import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة صافي المبيعات - احسب صافي الأرباح بدقة";
const DESCRIPTION =
  "استخدم حاسبة صافي المبيعات لحساب صافي الإيرادات من إجمالي المبيعات بعد خصم مردودات المبيعات والخصومات المسموح بها. تعد هذه الأداة مثالية للشركات وأصحاب الأعمال لمراقبة وتحليل الأداء المالي بدقة، وتساعد في إعداد تقارير مالية دقيقة وتحسين استراتيجيات التسويق والمبيعات.";
const KEYWORDS =
  "حاسبة صافي المبيعات, حساب صافي المبيعات, تحليل المبيعات, مردودات المبيعات, الخصومات المسموح بها, أدوات مالية, تقارير مالية, إدارة المبيعات";
const OG_URL = "https://do-calculate.com/calculator/ar/net-sales-calculator/";
const NetSalesCalculator = () => {
  const [totalSales, setTotalSales] = useState("");
  const [salesReturns, setSalesReturns] = useState("");
  const [allowedDiscounts, setAllowedDiscounts] = useState("");
  const [netSales, setNetSales] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const totalSalesValue = parseFloat(totalSales);
      const salesReturnsValue = parseFloat(salesReturns);
      const allowedDiscountsValue = parseFloat(allowedDiscounts);
      if (
        isNaN(totalSalesValue) ||
        isNaN(salesReturnsValue) ||
        isNaN(allowedDiscountsValue)
      ) {
        throw new Error("يرجى إدخال جميع القيم بشكل صحيح.");
      }
      if (
        totalSalesValue < 0 ||
        salesReturnsValue < 0 ||
        allowedDiscountsValue < 0
      ) {
        throw new Error("لا يمكن أن تكون القيم المدخلة سلبية.");
      }
      const calculatedNetSales =
        totalSalesValue - salesReturnsValue - allowedDiscountsValue;
      setNetSales(calculatedNetSales.toFixed(8));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة صافي المبيعات</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة صافي المبيعات هي أداة ضرورية لمساعدتك في حساب صافي
                  الإيرادات بدقة عن طريق خصم مردودات المبيعات والخصومات المسموح
                  بها من إجمالي المبيعات. باستخدام هذه الحاسبة، يمكنك بسهولة
                  تحديد الأرباح الصافية التي تحققها من خلال طرح التكاليف
                  المرتبطة بالمبيعات وتحليل الأداء المالي. تعد هذه الأداة مثالية
                  للشركات وأصحاب الأعمال لمراقبة الأداء المالي، وتحسين
                  استراتيجيات التسويق، وتقديم تقارير مالية دقيقة.
                </p>
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة صافي المبيعات</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          إجمالي المبيعات
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل إجمالي المبيعات"
                        value={totalSales}
                        onChange={(e) => setTotalSales(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          مردودات المبيعات
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل مردودات المبيعات"
                        value={salesReturns}
                        onChange={(e) => setSalesReturns(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          الخصم المسموح به
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل الخصم المسموح به"
                        value={allowedDiscounts}
                        onChange={(e) => setAllowedDiscounts(e.target.value)}
                        className="form-control"
                        style={{ width: "190px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <div>
                      <br />
                    </div>
                    { error && (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    )}
                    <br />
                    { netSales && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <p>صافي المبيعات:</p>
                        <p>{netSales}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هو صافي المبيعات؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                صافي المبيعات هو القيمة النهائية للإيرادات التي تحصل عليها
                الشركة بعد خصم جميع المردودات والخصومات. يُظهر هذا الرقم مقدار
                الدخل الفعلي الذي تتحقق منه الشركة بعد احتساب التعديلات اللازمة.
                صافي المبيعات يُستخدم كمؤشر رئيسي لقياس أداء الشركة المالي،
                ويُعتبر أساسياً في حساب مجمل الربح وتحليل كفاءة الأعمال. على
                سبيل المثال، إذا كان إجمالي المبيعات هو 5000 ر.س، وتمت معالجة
                مردودات بقيمة 300 ر.س وخصومات بقيمة 200 ر.س، فإن صافي المبيعات
                يكون 4500 ر.س.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>كيف يتم حساب صافي المبيعات؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                لحساب صافي المبيعات، يُخصم من إجمالي المبيعات كل من مردودات
                المبيعات والخصومات المسموح بها. الخطوات هي كما يلي:
                <ul>
                  <li>ابدأ بإجمالي المبيعات.</li>
                  <li>
                    اطرح قيمة مردودات المبيعات، وهي المبالغ المستردة من قبل
                    العملاء بسبب ردود أو أضرار.
                  </li>
                  <li>
                    اطرح قيمة الخصومات المسموح بها، وهي التخفيضات المقدمة
                    للعملاء.
                  </li>
                </ul>
                على سبيل المثال، إذا كان لديك إجمالي مبيعات قدره 1000 ر.س،
                ومردودات مبيعات قدرها 100 ر.س، وخصم مسموح به قدره 50 ر.س، فإن
                صافي المبيعات سيكون:
                <br />
                1000 ر.س - 100 ر.س - 50 ر.س = 850 ر.س.
                <br />
                هذا المبلغ يُمثل الإيرادات الفعلية التي تحققها الشركة من
                المبيعات بعد التعديلات.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NetSalesCalculator;
